











































import {Component, Inject, Vue, Watch} from "vue-property-decorator";
import MessageList from "./MessageList.vue";
import MessageDetail from "./MessageDetail.vue";
import MessageService from "../services/MessageService";
import GlobalEventBus from "../mixins/GlobalEventBus";
import UserStore from "../stores/UserStore";
import _ from "lodash";
import Helpers from "../utils/Helpers";

@Component({
  components: {
    MessageList,
    MessageDetail
  },
})
export default class MessageTab extends Vue {
  private selectedItem: any = null;
  private currentMessageListAction = 'inbox';
  private unreadCount = 0;
  private currentAction = '-1';
  private oldSelectedItem: any = null;
  private refreshSelectedItemTimeout?: number;
  private sending = false;

  private refreshTimeout?: number;
  @Inject()
  // @ts-ignore
  private userStore: UserStore;

  @Inject()
  // @ts-ignore
  private messageService: MessageService;

  public onSelectedMessageItem(data: any) {
    this.selectedItem = data;
    this.sending = false;
    if (this.currentMessageListAction === 'inbox' && !this.userStore.hasSeenMessage(data)) {
      this.messageService.seenMessage(data.id).then(() => {
        GlobalEventBus.$emit('seen-message', this.selectedItem);
        this.unreadCount--;
      });
    }
  }

  @Watch('selectedItem', {deep: true})
  updatedSelectedItem() {
    if (this.refreshSelectedItemTimeout) {
      clearTimeout(this.refreshSelectedItemTimeout);
    }
    if (!this.selectedItem) {
      this.oldSelectedItem = null;
      return;
    } else if (!this.oldSelectedItem) {
      this.oldSelectedItem = Helpers.deepCopy(this.selectedItem);
    }
    this.refreshSelectedItemTimeout = setTimeout(this.refreshSelectedItem, 3000);
  }

  refreshSelectedItem() {
    if (_.isEqual(this.selectedItem, this.oldSelectedItem) || this.oldSelectedItem.sent_at || this.selectedItem.subject.trim() === '' || this.selectedItem.body.trim() === '') {
      return;
    }
    this.messageService.modifyMessage(this.selectedItem).then(response => {
      this.oldSelectedItem = Helpers.deepCopy(response.data);
      this.selectedItem = response.data;
      GlobalEventBus.$emit('refreshed-message', this.selectedItem);
    });
  }

  createMessage() {
    this.selectedItem = {
      to: [],
      cc: [],
      subject: '',
      body: '',
      attachments: []
    }
  }

  mounted() {
    this.messageService.getUnreadCount().then(response => {
      this.unreadCount = response.data.count;
    });
    this.refreshTimeout = setTimeout(this.refresh, 15000);
  }

  beforeDestroy() {
    if (this.refreshTimeout) {
      clearTimeout(this.refreshTimeout);
    }
  }

  refresh() {
    if (this.refreshTimeout) {
      clearTimeout(this.refreshTimeout);
    }
    const all = [];
    all.push(this.messageService.getUnreadCount().then(response => {
      this.unreadCount = response.data.count;
    }));
    Promise.all(all).then(() => {
      this.refreshTimeout = setTimeout(this.refresh, 15000);
    }).catch(() => {
      this.refreshTimeout = setTimeout(this.refresh, 15000);
    })
  }

  sendMessage() {
    if (this.refreshSelectedItemTimeout) {
      clearTimeout(this.refreshSelectedItemTimeout);
    }
    this.sending = true;
    this.messageService.sendMessage(this.selectedItem).then(response => {
      GlobalEventBus.$emit('refreshed-message', response.data);
      this.selectedItem = null;
      this.sending = false;
      this.$toasted.show('Sent message successfully.', {
        theme: "toasted-primary",
        position: "bottom-center",
        duration: 2000
      });
    }).catch(() => {
      this.sending = false;
    });
  }

  messageListAction(action: string) {
    this.currentMessageListAction = action;
  }

  messageDetailAction(action: string) {
    if (this.currentAction === action) {
      return;
    }
    if (action === 'back') {
      this.selectedItem = null;
    } else if (action === 'archive') {
      this.messageService.archiveMessage(this.selectedItem.id).then(response => {
        GlobalEventBus.$emit('archived-message', this.selectedItem);
        this.selectedItem = null;
        this.$toasted.show('Archived message successfully.', {
          theme: "toasted-primary",
          position: "bottom-center",
          duration: 2000
        });
      });
    } else if (action === 'delete') {
      this.messageService.deleteMessage(this.selectedItem.id).then(response => {
        GlobalEventBus.$emit('deleted-message', this.selectedItem);
        this.selectedItem = null;
        this.$toasted.show('Deleted message successfully.', {
          theme: "toasted-primary",
          position: "bottom-center",
          duration: 2000
        });
      });
    } else if (action === 'unarchive') {
      this.messageService.unArchiveMessage(this.selectedItem.id).then(response => {
        GlobalEventBus.$emit('unarchived-message', this.selectedItem);
        this.selectedItem = null;
        this.$toasted.show('Moved message to inbox successfully.', {
          theme: "toasted-primary",
          position: "bottom-center",
          duration: 2000
        });
      });
    } else if (action === 'add-attachment') {
      const uploadFileInput = document.createElement('input');
      uploadFileInput.setAttribute('type', 'file');
      uploadFileInput.setAttribute('multiple', 'true');
      uploadFileInput.onchange = (event: Event) => {
        // @ts-ignore
        const files: Array<File> = event.target.files;
        for (const file of files) {
          const reader = new FileReader();
          reader.onload = (e: ProgressEvent) => {
            // @ts-ignore
            const fileReader: FileReader = e.target;
            this.selectedItem.attachments.push({
              file_name: file.name,
              content: (fileReader.result as string).split(',')[1]
            });
          };
          reader.readAsDataURL(file);
        }
      };
      uploadFileInput.click();
    } else if (action === 'reply') {
      this.selectedItem = {
        to: [this.selectedItem.from_user],
        cc: this.selectedItem.cc,
        subject: `RE: ${this.selectedItem.subject}`,
        body: '',
        attachments: []
      }
    }
    this.currentAction = String(Math.random());
  }

}
